import React from 'react';
import AppBackground from './containers/backgrounds/AppBackground';
import Header from './components/Header';
import PaymentState from './contexts/payment/paymentState';
import StoreContainer from './containers/StoreContainer';

const App = () => {
  return (
    <PaymentState>
      <AppBackground>
        <Header/>
        <StoreContainer/>
      </AppBackground>
    </PaymentState>
  );
};

export default App;
